export enum Types {
  SetWidth = "SET_WIDTH",
  SetCollapsed = "SET_COLLAPSED",
}
